import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How I became a 3 hour per day workout nutter",
  "description": "",
  "published": "2013-05-28T00:00:00.000Z",
  "redirect_from": ["/blog/how-i-became-a-3-hour-per-day-workout-nutter/swizec/6196"],
  "categories": "BMI, Body mass index, Boxing, Gym, Muscle, Physical exercise, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`On Sunday I went to boot camp - an hour of fast paced `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Calisthenics",
        "title": "Calisthenics"
      }}>{`calisthenics`}</a>{` - followed half an hour later by `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Boxing",
        "title": "Boxing"
      }}>{`boxing`}</a>{` practice. Three hours at the gym in total. On a sunny, if cold, Sunday afternoon. I had also spent half an hour working out that morning.`}</p>
    <p>{`That evening, whimpering in bed from muscle soreness, complaining loudly, but secretly enjoying every moment, it dawned on me that this might not be normal.`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/tAksLfZcRAmuZv2A4tIj",
        "alt": null
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/etIlPIqTRSiFoFDE4sQg",
        "alt": null
      }}></img></p>
    <p>{`Every day the internet tells me that as a human being of a sit-down, stare-at-a-computer persuasion, I should cower from physical strain. I should be looking up to the `}<a parentName="p" {...{
        "href": "http://frac.org/initiatives/hunger-and-obesity/obesity-in-the-us/"
      }}>{`30% of the population that isn't fat`}</a>{`, admire the perhaps 5% that's actually in shape, and shout profanities at society for making me feel bad about my body while nomming on a bag of crisps.`}</p>
    <p>{`If that's normal, then there is definitely something wrong with me. Deeply and horrifically wrong.`}</p>
    <p>{`Last week I spent 20 hours working out, the week before that it was 18. Both weeks I spent only 19 hours doing full on productive billable work. And about 18 hours writing.`}</p>
    <p>{`I also count calories, watch what I eat, and I don't even remember what a sugar craving feels like anymore.`}</p>
    <p>{`I must be deeply disturbed ...`}</p>
    <p>{`But how does a person even get to the point where a third of their productive time is spent working out?`}</p>
    <h2 {...{
      "id": "how-the-hell"
    }}>{`How the hell?`}</h2>
    <p>{`For me, it all started in high school. I was a scrawny kid, and I decided that this won't do and I want some muscle. Maybe I got mugged or something, can't remember the exact catalyst anymore.`}</p>
    <p>{`So I signed up for a gym membership and started weight lifting three days a week, an hour each. But I started getting bored and the results weren't coming quickly enough. The hour swelled up to two hours, then two and a half.`}</p>
    <p>{`Okay, this isn't sustainable, maybe I can partition my time better by working out six days a week for an hour.`}</p>
    <p>{`That eventually became six days a week for two hours.`}</p>
    <p>{`The results were spectacular. Like, truly magnificent. I weighed 65 kilograms and could squat just over 120 kilograms five times in a row.`}</p>
    <p>{`But I wanted more. More muscle. More weight. The plateau was immense, for the life of me I couldn't get my weight above the magic 25 `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Body_mass_index",
        "title": "Body mass index"
      }}>{`BMI`}</a>{` line. That's officially the top non-obese BMI you can have by the way.`}</p>
    <p>{`Then I got bored and who has time to work out six times a week when they're launching a startup anyway?`}</p>
    <p>{`So I started boxing. Just three days a week. Fun. With a proper trainer. About the same price. Marvelous!`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.omaa.org.uk/sites/default/files/Boxing-008.jpg",
        "alt": "THE boxing photo",
        "title": "THE boxing photo"
      }}></img></p>
    <p>{`In that first year or so of boxing, I fast realised boxing does much more than just get you in great physical shape. It's also a spectacular way to get in mental shape.`}</p>
    <p><em parentName="p">{`People annoying you all day?`}</em>{` Violently punch it out.`}</p>
    <p><em parentName="p">{`Been dealing with a pesky bug for a week?`}</em>{` Violently punch it out.`}</p>
    <p><em parentName="p">{`Intimidating meetings hard on your confidence?`}</em>{` No worries, you can beat the crap out of anyone in the room.`}</p>
    <p>{`Now, I'm not a violent man, but there's just something so primal, so very confidence inducing, about knowing not a single person in the room is a physical match for you. I can't really explain it, maybe it's just the difference between being a scrawny kid that's a head shorter than everyone, and being an agile pile of muscle that's a head shorter than everyone.`}</p>
    <p>{`And it goes so much further than just physical might and an escape into introversion. You become sort of calmer, more able to think things through ... it genuinely makes you better at your intellectual work.`}</p>
    <p>{`But we're still at just 5 hours a week. The final piece of the puzzle is my first trip to the US two years ago.`}</p>
    <p>{`Two weeks without boxing practice or any `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Physical_exercise",
        "title": "Physical exercise"
      }}>{`physical activity`}</a>{`? Now that just won't do will it? Time to start working out in the morning, just a few situps and pressups and such. No biggie.`}</p>
    <p>{`Fifteen minutes a day. Just enough to wake you up and keep you in shape somewhat, not enough to take any real amount of time. Perfect.`}</p>
    <p>{`When I cam back to Slovenia. I simply didn't stop. Eventually it ballooned to thirty minutes, then forty minutes. Lately I've started using `}<a parentName="p" {...{
        "href": "http://pumpup.co/"
      }}>{`PumpUp`}</a>{` to get new exercises and to get out of another plateau.`}</p>
    <p>{`The morning workouts ballooned to an hour and a half. Just over an hour if I completely destroy myself and barely take a moment to breathe.`}</p>
    <p>{`And so I became one of those nutters that spends at least an hour a day working out. Three hours on a good day ...`}</p>
    <p>{`But hey, at least I'm in shape for the inevitable zombie apocalypse or robot uprising. Right?`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=4e72e8c8-dd1e-4284-bed2-f6bbaec992ac",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      